import React from 'react';
import { Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import Menu from 'components/Menu';
import Heading from 'components/Heading';
import Lightbox from 'components/Lightbox';
import PlatformAnnouncementBanner from 'components/PlatformAnnouncementBanner';

import routes from 'routes';

const Default = ({ isMenuCollapsed }) => (
  <div className={`Dash ${isMenuCollapsed ? 'menu-collapsed' : ''}`}>
    <Lightbox />

    <div>
      <Menu />
    </div>

    <div>
      <main className='AppContent'>
        <PlatformAnnouncementBanner />
        <Heading />

        <Switch>
          {routes}
        </Switch>
      </main>
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  isMenuCollapsed: state.menu.isCollapsed,
});

export default connect(mapStateToProps)(Default);
